import styles from "./DateRangePickerComponent.module.scss";
import { DateRangePicker } from "react-date-range";
import { Button } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";
import { toDisplayTime } from "../../../../utilis/date-formats";


const DateRangePickerComponent = ({ onChange, handleCancel, selectedDate, firstAndLastDate, isMobile = false, maxDate }) => {
    const [selectedDateState, setSelectedDateState] = useState(selectedDate);

    const handleChange = useCallback(({ selection }) => {
        setSelectedDateState([selection]);
    }, []);

    const handleSave = useCallback(() => {
        onChange && onChange(selectedDateState)
    }, [onChange, selectedDateState]);

    return (
        <>
            <DateRangePicker
                onChange={handleChange}
                ranges={selectedDateState}
                showSelectionPreview={false}
                showDateDisplay={false}
                showMonthAndYearPickers={false}
                retainEndDateOnFirstSelection={true}
                months={isMobile ? 1 : 2}
                inputRanges={[]}
                direction="horizontal"
                className={styles.dateRangePickerClass}
                maxDate={maxDate ? new Date(maxDate) : undefined}
            />
            <div className={styles.buttonContainer}>
                {!isMobile && (
                    <div className={styles.adtDatesContainer}>
                        Available data range: {toDisplayTime(firstAndLastDate?.fromDate)} to {toDisplayTime(firstAndLastDate?.toDate)}. Please select a date within this range.
                    </div>
                )}
                <div className={styles.saveButton}>
                    <Button
                        onClick={handleSave}
                        variant="contained"
                        size="small"
                        sx={{
                            "@media (max-width: 768px)": {
                                fontSize: "10px",
                                height: "22px"
                            }
                        }}
                    >
                        Save
                    </Button>
                </div>
                <div className={styles.cancelButton}>
                    <Button
                        onClick={handleCancel}
                        className={styles.saveButton}
                        variant="outlined"
                        size="small"
                        sx={{
                            "@media (max-width: 768px)": {
                                fontSize: "10px",
                                height: "22px"
                            }
                        }}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </>
    );
};

export default DateRangePickerComponent;
